import { render, staticRenderFns } from "./RiskDefinition.vue?vue&type=template&id=2b7ada6c&scoped=true"
import script from "./RiskDefinition.vue?vue&type=script&lang=js"
export * from "./RiskDefinition.vue?vue&type=script&lang=js"
import style0 from "./RiskDefinition.vue?vue&type=style&index=0&id=2b7ada6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ada6c",
  null
  
)

export default component.exports